function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((element) => element.tabIndex >= 0 && !element.closest('[inert]') &&
    element.getClientRects().length > 0 && getComputedStyle(element).visibility === 'visible')
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  removeTrapFocus()
  trapFocusHandlers.keydown = function (event) {
    if (event.key !== 'Tab' || event.defaultPrevented) return
    // Recompute after dynamic controls (search clear/results, cart updates) change.
    const elements = getFocusableElements(container)
    const first = elements[0] || container
    const last = elements[elements.length - 1] || container
    // On the last focusable element and tab forward, focus the first element.
    if (!event.shiftKey && (event.target === last || !container.contains(event.target))) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first || !container.contains(event.target)) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('keydown', trapFocusHandlers.keydown)
  elementToFocus.focus({ preventScroll: true })
}

// Preserve existing inert state, including when a nested panel is opened.
function inertOutside(container, keep = []) {
  const changed = []
  for (let node = container; node.parentElement; node = node.parentElement) {
    for (const sibling of node.parentElement.children) {
      if (sibling === node || sibling.inert || keep.some(element => sibling.contains(element))) continue
      sibling.inert = true
      changed.push(sibling)
    }
    if (node.parentElement === document.body) break
  }
  return () => changed.forEach(element => { element.inert = false })
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    )
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document
    .querySelectorAll('product-model')
    .forEach((model) => model.modelViewerUI?.pause())
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

const serializeForm = (form) => {
  const obj = {}
  const formData = new FormData(form)
  for (const key of formData.keys()) {
    obj[key] = formData.get(key)
  }
  return JSON.stringify(obj)
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')
    const summaryElements = this.querySelectorAll('summary')
    this.addAccessibilityAttributes(summaryElements)

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      )

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    )
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    )
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute('role', 'button')
      element.setAttribute('aria-expanded', false)
      element.setAttribute('aria-controls', element.nextElementSibling.id)
    })
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const isOpen = detailsElement.hasAttribute('open')

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement)
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      )

      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
      })
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add('overflow-hidden-mobile')
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening')
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open')
        details.classList.remove('menu-opening')
      })
      this.mainDetailsToggle
        .querySelector('summary')
        .setAttribute('aria-expanded', false)
      document.body.classList.remove('overflow-hidden-mobile')
      removeTrapFocus(elementToFocus)
      this.closeAnimation(this.mainDetailsToggle)
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer()
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening')
    removeTrapFocus()
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends HTMLElement {
  connectedCallback() {
    this.events = new AbortController()
    const options = { signal: this.events.signal }
    this.mainDetailsToggle = this.querySelector('details')
    this.toggle = this.mainDetailsToggle.querySelector('summary')
    this.panels = []
    this.desktop = window.matchMedia('(min-width: 990px)')
    this.addEventListener('click', event => {
      const summary = event.target.closest('summary')
      const back = event.target.closest('.menu-drawer__close-button')
      if (summary && this.contains(summary)) {
        event.preventDefault()
        if (summary === this.toggle) this.mainDetailsToggle.open ? this.closeMenuDrawer() : this.openMenuDrawer()
        else this.openSubmenu(summary.parentElement)
      } else if (back) this.closeSubmenu()
    }, options)
    this.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !this.mainDetailsToggle.open) return
      event.preventDefault()
      event.stopPropagation()
      this.panels.length ? this.closeSubmenu() : this.closeMenuDrawer()
    }, options)
    this.desktop.addEventListener('change', () => {
      if (this.desktop.matches) this.closeMenuDrawer(false)
    }, options)
  }

  disconnectedCallback() {
    this.closeMenuDrawer(false)
    this.events.abort()
  }

  openMenuDrawer() {
    const header = this.closest('.section-header') || this.closest('.header-wrapper')
    document.documentElement.style.setProperty('--header-bottom-position', `${header.getBoundingClientRect().bottom}px`)
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
    this.mainDetailsToggle.open = true
    this.mainDetailsToggle.classList.add('menu-opening')
    this.setAttribute('role', 'dialog')
    this.setAttribute('aria-modal', 'true')
    this.setAttribute('aria-label', this.dataset.openLabel)
    this.toggle.setAttribute('aria-label', this.dataset.closeLabel)
    this.releaseBackground = inertOutside(this)
    this.wasScrollLocked = document.body.classList.contains('overflow-hidden-mobile')
    document.body.classList.add('overflow-hidden-mobile')
    trapFocus(this, this.toggle)
  }

  openSubmenu(details) {
    if (details.open) return
    details.open = true
    details.classList.add('menu-opening')
    const panel = details.querySelector('.menu-drawer__submenu')
    this.panels.push({ details, release: inertOutside(panel, [this.toggle]) })
    trapFocus(this, panel.querySelector('button'))
  }

  closeSubmenu(restoreFocus = true) {
    const panel = this.panels.pop()
    if (!panel) return
    panel.release()
    panel.details.open = false
    panel.details.classList.remove('menu-opening')
    if (restoreFocus) trapFocus(this, panel.details.querySelector('summary'))
  }

  closeMenuDrawer(restoreFocus = true) {
    if (!this.mainDetailsToggle?.open) return
    while (this.panels.length) this.closeSubmenu(false)
    this.releaseBackground?.()
    this.mainDetailsToggle.open = false
    this.mainDetailsToggle.classList.remove('menu-opening')
    this.removeAttribute('role')
    this.removeAttribute('aria-modal')
    this.removeAttribute('aria-label')
    this.toggle.setAttribute('aria-label', this.dataset.openLabel)
    if (!this.wasScrollLocked) document.body.classList.remove('overflow-hidden-mobile')
    removeTrapFocus(restoreFocus ? this.toggle : null)
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    )
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
    })
    this.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && this.hasAttribute('open')) this.hide()
    })
  }

  show(opener) {
    this.openedBy = opener
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    this.querySelector('.template-popup')?.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      'click',
      this.loadContent.bind(this)
    )
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)
      window.pauseAllMedia()
      this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      ).focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class CalculateWrapperHeight {
  constructor(element) {
    this.element = document.querySelector(element)
    this.windowHeight = 0
    this.wrapperHeight = 0
  }

  setWrapperHeight() {
    this.wrapperHeight = window.innerHeight - this.element.offsetTop
  }

  setElementHeight() {
    if (!typeof this.element === 'string' || this.element instanceof String)
      return
    this.setWrapperHeight()
    this.element.style.height = `${this.wrapperHeight}px`
  }

  resetHeight() {
    if (!typeof this.element === 'string' || this.element instanceof String)
      return
    this.element.style.height = ''
  }
}

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname === 'pro.statsports.com') {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
